// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b68b3e3c","239":"22807499","453":"bf996e1c","455":"92b42dec"}[chunkId] + ".chunk.js";
};